import React from "react";
import QuotePage from "../../lib/Pages/Quote";

export default function QuoteRoute() {
  return <QuotePage />;
}
